import { FicheContainer, useFiche } from '@mairistem/fiche';
import React from 'react';
import { toast } from 'react-toastify';

import { baseUrl } from '@/routes';
import type { ErrorFieldType } from '@/types';
import { validateRegie } from '@/utils';
import { parseApiBusinessError, parseApiValidationErrors } from '@/utils/apiErrors';
import { ModeReglementContextProvider, ProduitContextProvider } from '../Context';
import ConstitutionRegieRouter from './ConstitutionRegieRouter';
import ConstitutionRegieFiche from './Fiche/ConstitutionRegieFiche';
import ConstitutionRegieFicheBar from './Fiche/ConstitutionRegieFicheBar';

const MenuConstitution = () => {
  const [service] = useFiche(`${baseUrl}/regies`);

  const handleValidate = React.useCallback(
    (data: any): ErrorFieldType[] => validateRegie(data),
    [],
  );

  const handleApiError = React.useCallback((errorData) => {
    const status = errorData?.code;

    // 422 - Erreurs de validation serveur
    if (status === 422 || errorData?.message?.errors) {
      const fieldErrors = parseApiValidationErrors(errorData?.message);

      return fieldErrors;
    }

    // 500/autre - Erreurs métier ou génériques
    const { fieldErrors, toastMessage } = parseApiBusinessError(errorData?.message ?? errorData);

    toast.error(toastMessage);

    if (fieldErrors.length > 0) return fieldErrors;

    return undefined;
  }, []);

  return (
    <ConstitutionRegieRouter>
      <ProduitContextProvider>
        <ModeReglementContextProvider autoload="régie">
          <FicheContainer
            service={service}
            type="regie"
            onValidate={handleValidate}
            onApiError={handleApiError}
          >
            {(p) => (
              <>
                <ConstitutionRegieFicheBar {...p} />
                <ConstitutionRegieFiche {...p} />
              </>
            )}
          </FicheContainer>
        </ModeReglementContextProvider>
      </ProduitContextProvider>
    </ConstitutionRegieRouter>
  );
};

export default MenuConstitution;
